import React from "react";
import { connect } from "react-redux";

import Helmet from 'react-helmet';

import DateFnsUtils from "@date-io/date-fns";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { StylesProvider } from "@material-ui/styles";
import { ThemeProvider } from "styled-components";

import { useTranslation } from "react-i18next";

import maTheme from "./theme";
import Routes from "./routes/Routes";

function App({ theme }) {
  const { t, i18n } = useTranslation();

  const selectedTheme = maTheme[theme.currentTheme](i18n.language);

  return (
    <React.Fragment>
      <Helmet
        titleTemplate="%s | MonCompte Partenaires"
        defaultTitle="MonCompte Partenaires"
      />
      <StylesProvider injectFirst>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <MuiThemeProvider theme={selectedTheme}>
            <ThemeProvider theme={selectedTheme}>
              <Routes />
            </ThemeProvider>
          </MuiThemeProvider>
        </MuiPickersUtilsProvider>
      </StylesProvider>
    </React.Fragment>
  );
}

export default connect(store => ({ theme: store.themeReducer }))(App);
